// ═══════════════════════════════════════════════
//   KONBINI RUSH — alien customers minigame
// ═══════════════════════════════════════════════
//
// Objective:   Serve each alien customer by clicking the product they ask
//              for in their speech bubble.
// Type:        quiz
// Description: A customer appears with a wanted product in a speech bubble;
//              click the matching product card. Wrong answers and timeouts
//              cost 1 HP (GAME_WORKERS.lives total). Time-per-question
//              shrinks and option count grows with score; run ends at HP 0.
// Tunables:    GAME_WORKERS in data.js.

const {ALIENS, ALIEN_KEYS, canvas, ctx, claimGameReward, GAME_WORKERS, addCleanup, showGameOver, setHP, loseHP} = window;

let krProds = [], krAlienImgs = {};
window.krWant = null;
window.krOpts = [];
window.krCustomer = null;
window.krFlash = 0;
window.krQuestionStart = 0;
window.krTimeLimit = 0;
let krFlashOk = false, krAnswered = false;

function startWorkers() {
    window.gameRunning = true;
    window.gameScore = 0;
    window.krQuestionStart = 0;
    window.krTimeLimit = 0;
    krProds = [];
    krAnswered = false;
    window.krFlash = 0;
    window.krCustomer = null;
    setHP(GAME_WORKERS.lives, GAME_WORKERS.lives);
    document.getElementById('mg-score').textContent = '0';
    // Probe product images
    let pp = 8, found = [];
    for (let i = 1; i <= 8; i++) {
        const img = new Image(), id = i;
        img.onload = () => {
            found.push({id, img, emoji: null});
            --pp || krLoadAliens(found);
        };
        img.onerror = () => {
            --pp || krLoadAliens(found);
        };
        img.src = `assets/products/product_${i}.png`;
    }
}

function krLoadAliens(found) {
    krProds = found.length >= 2 ? found : ['🥫', '🍙', '🍜', '🍵'].map((e, i) => ({id: i + 1, img: null, emoji: e}));
    // Preload alien images
    let ap = ALIEN_KEYS.length || 1;
    ALIEN_KEYS.forEach(k => {
        const img = new Image();
        img.onload = img.onerror = () => {
            --ap <= 0 && krBegin();
        };
        img.src = ALIENS[k].img;
        krAlienImgs[k] = img;
    });
    if (!ALIEN_KEYS.length) krBegin();
}

function krBegin() {
    window.gameInterval = setInterval(krDraw, 16);
    addCleanup(() => clearInterval(window.gameInterval));
    canvas.addEventListener('click', krClick);
    addCleanup(() => canvas.removeEventListener('click', krClick));
    addCleanup(() => {
        window.krCustomer = null;
        window.krWant = null;
        window.krOpts = [];
        window.krFlash = 0;
    });
    krNextCustomer();
}

function krNextCustomer() {
    krAnswered = false;
    window.krFlash = 0;
    window.krQuestionStart = Date.now();
    window.krTimeLimit = Math.max(GAME_WORKERS.timeMin, GAME_WORKERS.timeBase - window.gameScore * GAME_WORKERS.timeRamp);
    const key = ALIEN_KEYS[Math.floor(Math.random() * ALIEN_KEYS.length)];
    window.krCustomer = {key, img: krAlienImgs[key], name: ALIENS[key].name};
    window.krWant = krProds[Math.floor(Math.random() * krProds.length)];
    // Option count grows with score: 4 → 5 → 6 (capped by available products)
    const numOpts = Math.min(krProds.length,
        Math.min(GAME_WORKERS.optionsMax,
            GAME_WORKERS.optionsBase + Math.floor(window.gameScore / GAME_WORKERS.optionsScaleAt)));
    const wrong = krProds.filter(p => p.id !== window.krWant.id).sort(() => Math.random() - .5).slice(0, numOpts - 1);
    const pool = [window.krWant, ...wrong].sort(() => Math.random() - .5);
    const gap = 5, ch = 78, margin = 16;
    const cw = Math.floor((canvas.width - margin - gap * (pool.length - 1)) / pool.length);
    const totalW = cw * pool.length + gap * (pool.length - 1);
    const sx = Math.floor((canvas.width - totalW) / 2);
    const sy = canvas.height - ch - 12;
    window.krOpts = pool.map((p, i) => ({...p, x: sx + i * (cw + gap), y: sy, w: cw, h: ch}));
}

function krClick(e) {
    if (!window.gameRunning || krAnswered || window.krFlash > 0) return;
    const {x: mx, y: my} = canvasPos(e);
    for (const o of window.krOpts) {
        if (mx >= o.x && mx <= o.x + o.w && my >= o.y && my <= o.y + o.h) {
            krAnswered = true;
            krFlashOk = o.id === window.krWant.id;
            if (krFlashOk) {
                window.gameScore++;
                document.getElementById('mg-score').textContent = window.gameScore;
                SFX.play('pts');
            } else {
                loseHP();
                SFX.play('error');
            }
            window.krFlash = 36;
            setTimeout(() => {
                if (!window.gameRunning) return;
                if (window.gameHP <= 0) endWorkers();
                else krNextCustomer();
            }, 520);
            break;
        }
    }
}

function krDrawImg(img, emoji, x, y, w, h, alpha) {
    ctx.globalAlpha = alpha ?? 1;
    if (img && img.complete && img.naturalWidth > 0) {
        const r = Math.min((w - 4) / img.naturalWidth, (h - 4) / img.naturalHeight);
        const iw = img.naturalWidth * r, ih = img.naturalHeight * r;
        ctx.drawImage(img, x + (w - iw) / 2, y + (h - ih) / 2, iw, ih);
    } else if (emoji) {
        ctx.font = `${Math.floor(h * .55)}px serif`;
        ctx.textAlign = 'center';
        ctx.fillText(emoji, x + w / 2, y + h * .75);
    }
    ctx.globalAlpha = 1;
}

function krDraw() {
    if (!window.gameRunning) return;

    // Per-question countdown — fires once when time hits 0
    const krTimeLeft = window.krTimeLimit > 0
        ? Math.max(0, window.krTimeLimit - (Date.now() - window.krQuestionStart) / 1000)
        : window.krTimeLimit;
    if (!krAnswered && window.krTimeLimit > 0 && krTimeLeft <= 0) {
        krAnswered = true;
        krFlashOk = false;
        window.krFlash = 36;
        loseHP();
        SFX.play('error');
        setTimeout(() => {
            if (!window.gameRunning) return;
            if (window.gameHP <= 0) endWorkers();
            else krNextCustomer();
        }, 520);
    }

    if (window.krFlash > 0) window.krFlash--;
    const W = canvas.width, H = canvas.height;
    // BG — warm konbini interior
    ctx.fillStyle = '#fef3e2';
    ctx.fillRect(0, 0, W, H);
    // Tile wall
    ctx.strokeStyle = '#e8d5b7';
    ctx.lineWidth = 1;
    for (let x = 0; x < W; x += 40) for (let y = 0; y < 158; y += 40) {
        ctx.beginPath();
        ctx.roundRect(x + 1, y + 1, 38, 38, 3);
        ctx.stroke();
    }
    // Counter
    ctx.fillStyle = '#c8975a';
    ctx.fillRect(0, 154, W, 14);
    ctx.fillStyle = '#9e6b35';
    ctx.fillRect(0, 168, W, 5);
    // Counter surface
    ctx.fillStyle = '#e8c48a';
    ctx.fillRect(0, 173, W, 32);
    ctx.strokeStyle = '#9e6b35';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(0, 205);
    ctx.lineTo(W, 205);
    ctx.stroke();
    // Floor
    ctx.fillStyle = '#f5e6c8';
    ctx.fillRect(0, 205, W, H - 205);

    // Flash feedback on upper half
    if (window.krFlash > 0) {
        ctx.fillStyle = krFlashOk ? `rgba(168,224,99,${window.krFlash / 36 * .35})` : `rgba(247,37,133,${window.krFlash / 36 * .28})`;
        ctx.fillRect(0, 0, W, 154);
        ctx.font = 'bold 10px "Press Start 2P",monospace';
        ctx.textAlign = 'center';
        ctx.fillStyle = krFlashOk ? '#166534' : '#f72585';
        ctx.globalAlpha = window.krFlash / 36;
        ctx.fillText(krFlashOk ? 'CORRECT! ✓' : 'WRONG! ✗', W / 2, 82);
        ctx.globalAlpha = 1;
    }

    // Alien customer
    if (window.krCustomer?.img?.complete && window.krCustomer.img.naturalWidth > 0) {
        const iw = window.krCustomer.img.naturalWidth, ih = window.krCustomer.img.naturalHeight;
        const maxH = 148, maxW = 100;
        const r = Math.min(maxW / iw, maxH / ih);
        ctx.drawImage(window.krCustomer.img, 8 + (maxW - iw * r) / 2, 154 - ih * r, iw * r, ih * r);
    } else {
        ctx.font = '68px serif';
        ctx.textAlign = 'center';
        ctx.fillText('👾', 58, 148);
    }

    // Speech bubble
    const bx = 118, by = 10, bw = 236, bh = 132;
    ctx.fillStyle = 'white';
    ctx.strokeStyle = '#1a0010';
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.roundRect(bx, by, bw, bh, 14);
    ctx.fill();
    ctx.stroke();
    // tail
    ctx.fillStyle = 'white';
    ctx.beginPath();
    ctx.moveTo(bx + 14, by + bh);
    ctx.lineTo(bx - 12, by + bh + 20);
    ctx.lineTo(bx + 34, by + bh);
    ctx.fill();
    ctx.strokeStyle = '#1a0010';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(bx + 14, by + bh + 1);
    ctx.lineTo(bx - 12, by + bh + 20);
    ctx.lineTo(bx + 34, by + bh + 1);
    ctx.stroke();
    // text
    ctx.fillStyle = '#1a0010';
    ctx.font = '6px "Press Start 2P",monospace';
    ctx.textAlign = 'center';
    ctx.fillText("Excuse me, I'd like one", bx + bw / 2, by + 20);
    ctx.fillText('of these please!', bx + bw / 2, by + 34);
    // wanted product image inside bubble
    if (window.krWant) {
        const px = bx + (bw - 70) / 2, py = by + 42, pw = 70, ph = 72;
        krDrawImg(window.krWant.img, window.krWant.emoji, px, py, pw, ph, 1);
    }

    // Hand tray
    ctx.fillStyle = 'rgba(255,240,214,.97)';
    ctx.fillRect(0, H - 100, W, 100);
    ctx.strokeStyle = '#f9a8d4';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(0, H - 100);
    ctx.lineTo(W, H - 100);
    ctx.stroke();
    ctx.font = '5px "Press Start 2P",monospace';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#c05070';
    ctx.fillText('CLICK THE RIGHT PRODUCT', W / 2, H - 89);

    // Option cards
    for (const o of window.krOpts) {
        const isRight = o.id === window.krWant?.id;
        if (krAnswered && window.krFlash > 0) {
            ctx.fillStyle = isRight ? 'rgba(168,224,99,.55)' : 'rgba(240,240,240,.7)';
            ctx.strokeStyle = isRight ? '#a8e063' : '#ccc';
        } else {
            ctx.fillStyle = 'white';
            ctx.strokeStyle = '#1a0010';
        }
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.roundRect(o.x, o.y, o.w, o.h, 8);
        ctx.fill();
        ctx.stroke();
        krDrawImg(o.img, o.emoji, o.x + 2, o.y + 2, o.w - 4, o.h - 4, 1);
    }

    // Time bar — drawn last so it sits over everything
    if (!krAnswered && window.krTimeLimit > 0) {
        const frac = krTimeLeft / window.krTimeLimit;
        const barColor = frac > 0.55 ? '#a8e063' : frac > 0.28 ? '#f5c842' : '#f72585';
        ctx.fillStyle = 'rgba(0,0,0,0.22)';
        ctx.fillRect(0, 0, W, 7);
        ctx.fillStyle = barColor;
        ctx.fillRect(0, 0, Math.round(W * frac), 7);
    }
}

function endWorkers() {
    window.gameRunning = false;
    SFX.play('gameover');
    if (window.gameScore >= GAME_WORKERS.nickThreshold) window.unlockNick('staff');
    const p = Math.min(GAME_WORKERS.rewardMax, window.gameScore * GAME_WORKERS.rewardPer);
    showGameOver(claimGameReward('workers', window.gameScore, p));
}


window.startWorkers = startWorkers;
window.krClick = krClick;
window.endWorkers = endWorkers;
